import Users from './User'

export default Users